import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _name$components$data;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { allProductList, searchProduct, searchProductPro } from "@/api/management/productMapping";
import { search_product_blend } from "@/api/management/productMapping";
import { Loading } from "element-ui";
import { mapState, mapActions } from "vuex";
import { menuAside, menuHeader } from "@/menu";
import latests from "./componetsPage/latests.vue";
import oneHour from "./componetsPage/oneHour.vue";
import comparison from "./componetsPage/comparison.vue";
import rollSuit from "./componetsPage/rollSuit.vue";
import allRechargeP from "./componetsPage/allRechargeP.vue";
import { updateUserState } from "@/api/auth/onlineUser";
export default (_name$components$data = {
  name: "index",
  components: {
    latests: latests,
    oneHour: oneHour,
    comparison: comparison,
    rollSuit: rollSuit,
    allRechargeP: allRechargeP
  },
  data: function data() {
    return {
      loading: null,
      featureList: [],
      checkAll: false,
      isIndeterminate: false,
      checkedCities: [],
      ProductList: [],
      activeIndex: "-1",
      isSpecial: false,
      // 项目总览权限控制
      RollSuit: false,
      // 滚服权限控制
      kamitakuItemList: [],
      itemList: []
    };
  },
  created: function created() {
    var _this = this;

    this.$bus.$on("upds", function () {
      _this.functionMenuData();
    });
    this.getsearchProduct();
  },
  activated: function activated() {
    this.kamitakuItemList = [];
    this.itemList = [];
    this.getsearchProduct();
    this.$refs.comModule0 && this.$refs.comModule0.gettingData();
    this.$refs.comModule1 && this.$refs.comModule1.gettingData();
    this.$refs.comModule2 && this.$refs.comModule2.gettingData();
    this.$refs.comModule4 && this.$refs.comModule4.gettingData();
    this.$refs.comModule5 && this.$refs.comModule5.gettingData();
  },
  watch: {},
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "user.isSpecial",
                user: true
              }, {
                root: true
              });

            case 2:
              _this2.isSpecial = _context.sent;

              _this2.severShow();

              _this2.activeIndex = "0";

              _this2.functionMenuData();

              _this2.$bus.$on("updProductS", function () {
                _this2.kamitakuItemList = [];
                _this2.itemList = [];

                _this2.getsearchProduct();
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin/serchSelect", ["HomePageState", "searchpkgs", "advchannels", "advLocation", "kamitakuSearchData", "royalpirates"])), mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    },
    is_show_homes: function is_show_homes(state) {
      return state.user.is_show_home;
    },
    game_show_type: function game_show_type(state) {
      return state.user.game_show_type;
    },
    rawData: function rawData(state) {
      return state.serchSelect.rawData;
    }
  })),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {// vm.kamitakuItemList = [];
      // vm.itemList = [];
      // vm.getsearchProduct();
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next(this.cancelfimFeature());
  }
}, _defineProperty(_name$components$data, "watch", {}), _defineProperty(_name$components$data, "methods", {
  // 服务器展示判断
  severShow: function severShow() {
    if (this.rawData.game_mark.indexOf(this.royalpirates) > -1) {
      this.RollSuit = this.severlist.length ? true : false;
    } else if (this.rawData.game_mark.indexOf("yjfm") > -1) {
      this.RollSuit = true;
    }
  },
  handleSelect: function handleSelect(e) {
    this.activeIndex = e;
  },
  functionMenuData: function functionMenuData() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var list;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this3.featureList = window.localStorage.getItem("Menu") ? JSON.parse(window.localStorage.getItem("Menu")) : [];
              _context2.next = 3;
              return _this3.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "menu.accessMenus",
                defaultValue: [],
                user: true
              }, {
                root: true
              });

            case 3:
              list = _context2.sent;
              _this3.checkedCities = list.map(function (item) {
                return _this3.featureList.filter(function (i) {
                  return (i === null || i === void 0 ? void 0 : i.title) == item.title;
                })[0];
              });
              _this3.checkedCities = _this3.checkedCities.map(function (item) {
                if (item) {
                  return item.id;
                }
              });
              _this3.checkedCities = _this3.checkedCities.filter(function (elm) {
                return elm;
              });
              _this3.isIndeterminate = _this3.checkedCities.length && _this3.checkedCities.length != _this3.featureList.length ? true : false;
              _this3.checkAll = _this3.checkedCities.length == _this3.featureList.length ? true : false;

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  // 获取游戏列表
  getsearchProduct: function getsearchProduct() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return search_product_blend().then(function (res) {
                if (res.code == 200) {
                  _this4.itemList = res.data;
                }
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  // 功能菜单设置
  confimFeature: function confimFeature() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var list, isLargeScreenData, accessMenus, accessMenusList, Settings;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              list = _this5.featureList.map(function (item) {
                if (_this5.checkedCities.find(function (i) {
                  return i == item.id;
                })) {
                  return item;
                }
              });

              if (list.length) {
                _context4.next = 4;
                break;
              }

              _this5.$message.error("请选择");

              return _context4.abrupt("return");

            case 4:
              list = list.filter(function (elm) {
                return elm;
              });
              _context4.next = 7;
              return _this5.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "user.islargeScreenData",
                defaultValue: false,
                user: true
              }, {
                root: true
              });

            case 7:
              isLargeScreenData = _context4.sent;

              _this5.$store.dispatch("d2admin/page/openedLoad");

              _context4.next = 11;
              return _this5.$store.dispatch("d2admin/permission/generateAccessMenus", list);

            case 11:
              accessMenus = _context4.sent;
              accessMenusList = isLargeScreenData ? [{
                path: "/largeScreenData",
                title: "大屏数据",
                icon: "signal"
              }].concat(_toConsumableArray(accessMenus)) : accessMenus; // 设置顶栏菜单

              _this5.$store.commit("d2admin/menu/headerSet", [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenusList))); // 设置侧边栏菜单


              _this5.$store.commit("d2admin/menu/asideSet", [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenusList))); // 初始化菜单搜索功能


              _this5.$store.commit("d2admin/search/init", [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenusList)));

              _context4.next = 18;
              return _this5.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "menu.accessMenus",
                value: accessMenusList,
                user: true
              }, {
                root: true
              });

            case 18:
              _context4.next = 20;
              return _this5.$store.dispatch("d2admin/page/closeAllt", {}, {
                root: true
              });

            case 20:
              _this5.$store.dispatch("d2admin/serchSelect/setPageStatus", "");

              _context4.next = 23;
              return _this5.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "menu.Settings",
                defaultValue: "",
                user: true
              }, {
                root: true
              });

            case 23:
              Settings = _context4.sent;

              if (!Settings) {
                _this5.$store.dispatch("d2admin/serchSelect/setPageStatus", 1);
              }

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  // 取消功能菜单设置
  cancelfimFeature: function cancelfimFeature() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var accessMenus, allMenuAside, allMenuHeader;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "menu.accessMenus",
                defaultValue: [],
                user: true
              }, {
                root: true
              });

            case 2:
              accessMenus = _context5.sent;

              if (accessMenus.length) {
                _context5.next = 6;
                break;
              }

              _this6.$message.error('请设置功能菜单');

              return _context5.abrupt("return");

            case 6:
              allMenuAside = [].concat(_toConsumableArray(menuAside), _toConsumableArray(accessMenus));
              allMenuHeader = [].concat(_toConsumableArray(menuHeader), _toConsumableArray(accessMenus)); // 设置顶栏菜单

              _this6.$store.commit("d2admin/menu/headerSet", allMenuHeader); // 设置侧边栏菜单


              _this6.$store.commit("d2admin/menu/asideSet", allMenuAside); // 初始化菜单搜索功能


              _this6.$store.commit("d2admin/search/init", allMenuHeader);

              _this6.$store.dispatch("d2admin/serchSelect/setPageStatus", _this6.HomePageState == 2 ? "" : _this6.HomePageState);

            case 12:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  handleCheckAllChange: function handleCheckAllChange(val) {
    this.checkedCities = val ? this.featureList.map(function (item) {
      return item.id;
    }) : [];
    this.isIndeterminate = false;
  },
  handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
    value = value.filter(function (elm) {
      return elm;
    });
    var checkedCount = value.length;
    this.checkAll = checkedCount == this.featureList.length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.featureList.length;
  },
  // 游戏产品设置
  closeItem: function closeItem(items) {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var query, list;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return updateUserState({
                version: process.env.VUE_APP_VERSION_NEW
              });

            case 2:
              _this7.loading = Loading.service({
                lock: true,
                text: "设置中",
                background: "rgba(0, 0, 0, 0.7)"
              });
              _context6.next = 5;
              return _this7.$store.dispatch("d2admin/page/closeAllt", {}, {
                root: true
              });

            case 5:
              _this7.$store.commit("d2admin/serchSelect/setreqPayList", false);

              _this7.$store.commit("d2admin/serchSelect/setreqCurrency", false);

              _this7.$store.commit("d2admin/serchSelect/setreqCountryList", false);

              _this7.$store.commit("gmTool/init/set_itemList", []);

              _this7.$store.commit("gmTool/init/set_isreqItemList", false);

              _this7.$store.commit("gmTool/init/set_serverList", []);

              _this7.$store.commit("gmToolYJ/init/set_serverListYJ", []);

              _context6.next = 14;
              return _this7.$store.dispatch("d2admin/user/gameShowType", items.game_show_type);

            case 14:
              _context6.next = 16;
              return _this7.$store.dispatch("d2admin/serchSelect/setGame", items);

            case 16:
              query = _context6.sent;

              if (!(query.code == 200)) {
                _context6.next = 27;
                break;
              }

              _context6.next = 20;
              return _this7.$store.dispatch("d2admin/db/set", {
                dbName: "sys",
                path: "menu.Settings",
                value: true,
                user: true
              }, {
                root: true
              });

            case 20:
              _context6.next = 22;
              return _this7.$store.dispatch("d2admin/db/get", {
                dbName: "sys",
                path: "menu.accessMenus",
                defaultValue: [],
                user: true
              }, {
                root: true
              });

            case 22:
              list = _context6.sent;

              if (list.length) {
                _this7.$store.dispatch("d2admin/serchSelect/setPageStatus", "");

                _this7.activeIndex = "0";
              } else {
                _this7.$store.dispatch("d2admin/serchSelect/setPageStatus", 2);
              }

              _this7.severShow();

              _context6.next = 28;
              break;

            case 27:
              _this7.$message({
                type: "error",
                message: "设置失败!"
              });

            case 28:
              _this7.loading.close();

            case 29:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  // 取消游戏产品设置
  cancelCloseItem: function cancelCloseItem() {
    this.$store.dispatch("d2admin/serchSelect/setPageStatus", "");
    this.cancelfimFeature();
  }
}), _name$components$data);